import {
  CircularProgress,
  List,
  ListItem,
  ListItemText,
} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import { useCallback, useEffect, useRef, useState } from "react";

export default function Search({ label, fetch, onResult, style }) {
  const [text, setText] = useState("");
  const [result, setResult] = useState(null);
  const debounce = useRef(null);

  const handleChange = useCallback(
    (evt) => {
      if (debounce) {
        clearTimeout(debounce.current);
      }

      debounce.current = setTimeout(() => {
        setText(evt.target.value);
      }, 700);
    },
    [debounce]
  );

  useEffect(() => {
    fetch(text).then(setResult);
  }, [fetch, text]);

  useEffect(() => {
    onResult(result);
  }, [onResult, result]);

  return (
    <TextField
      id="outlined-basic"
      placeholder={label}
      inputProps={{ style: { textAlign: "center", height: 32, padding: 0 } }}
      variant="outlined"
      onChange={handleChange}
      style={{
        backgroundColor: "#ffffff",
        pointerEvents: "all",
        height: 32,
        ...style,
      }}
    />
  );
}

export const Suggestions = ({ data, onSelect, loading, style }) => {
  if (loading) {
    return (
      <List
        style={{
          ...style,
          backgroundColor: "#ffffff",
          pointerEvents: "all",
        }}
      >
        <ListItem>
          <CircularProgress color="primary" />
        </ListItem>
      </List>
    );
  }

  return (data?.length ?? 0) > 0 ? (
    <List
      style={{
        ...style,
        backgroundColor: "#ffffff",
        pointerEvents: "all",
      }}
    >
      {data.map((d, idx) => (
        <ListItem
          key={idx}
          divider={true}
          button={true}
          onClick={() => onSelect(d)}
        >
          <ListItemText>{d.name}</ListItemText>
        </ListItem>
      ))}
    </List>
  ) : (
    ""
  );
};
